import {
  createStyles,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Theme,
} from '@material-ui/core'
import { ReactNode, useCallback, useMemo, useState } from 'react'
import MenuIcon from '@material-ui/icons/Menu'
import CodeIcon from '@material-ui/icons/Code'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import { useLocation, useNavigate } from 'react-router-dom'
import { AirplanemodeActive, CloudUpload, FlashOn } from '@material-ui/icons'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: {
      color: 'white',
    },
    listItem: {
      paddingRight: theme.spacing(5),
    },
  }),
)

export const SideBar = (): JSX.Element => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const items = useMemo<{ route: string; text: string; icon: ReactNode }[]>(
    () => [
      { route: '/', text: 'Start Engine', icon: <CodeIcon /> },
      { route: '/uploadIssues', text: 'Upload Issues', icon: <CloudUpload /> },
      { route: '/admin', text: 'Admin', icon: <SupervisorAccountIcon /> },
      {
        route: '/executions',
        text: 'Executions',
        icon: <AirplanemodeActive />,
      },
      { route: '/fasttrack', text: 'Fast Track', icon: <FlashOn /> },
    ],
    [],
  )

  const handleListItemClicked = useCallback(
    (route: string) => {
      navigate(process.env.PUBLIC_URL + route)
      setIsOpen(false)
    },
    [navigate],
  )

  return (
    <>
      <IconButton className={classes.icon} onClick={() => setIsOpen(true)}>
        <MenuIcon />
      </IconButton>
      <Drawer anchor='left' open={isOpen} onClose={() => setIsOpen(false)}>
        <List>
          {items.map((item) => (
            <ListItem
              button
              key={item.route}
              selected={item.route === pathname}
              onClick={() => handleListItemClicked(item.route)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText className={classes.listItem} primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  )
}
